
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface SelectFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  options: { value: string; label: string }[] | string[];
  showCustomInput?: boolean;
  customValue?: string;
  onCustomChange?: (value: string) => void;
  customError?: string;
  customPlaceholder?: string;
}

const SelectField = ({ 
  id, 
  label, 
  value, 
  onChange, 
  error, 
  placeholder, 
  options,
  showCustomInput,
  customValue,
  onCustomChange,
  customError,
  customPlaceholder
}: SelectFieldProps) => {
  const isStringArray = typeof options[0] === 'string';
  
  return (
    <div>
      <Label htmlFor={id} className="text-black font-medium">
        {label}
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className={`mt-2 h-12 ${error ? 'border-red-500' : 'border-[#cccccc]'}`}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className="bg-white">
          {options.map((option) => {
            const optionValue = isStringArray ? option as string : (option as { value: string; label: string }).value;
            const optionLabel = isStringArray ? option as string : (option as { value: string; label: string }).label;
            
            return (
              <SelectItem key={optionValue} value={optionValue}>
                {optionLabel}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
      
      {showCustomInput && (
        <div className="mt-3">
          <Input
            type="text"
            value={customValue || ''}
            onChange={(e) => onCustomChange?.(e.target.value)}
            className={`h-12 ${customError ? 'border-red-500' : 'border-[#cccccc]'}`}
            placeholder={customPlaceholder}
          />
          {customError && (
            <p className="text-red-500 text-sm mt-1">{customError}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectField;
